export interface FirebaseRuntimeConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
}

export interface RuntimeConfig {
  appName: string;
  apiBaseUrl: string;
  firebaseConfig: FirebaseRuntimeConfig;
  featureFlags: Record<string, boolean>;
}

export const defaultRuntimeConfig: RuntimeConfig = {
  appName: 'Validador de Documentos',
  apiBaseUrl: '',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },
  featureFlags: {},
};
